module.exports = __webpack_public_path__ + "img/image166.3279edad.jpg";